// src/redux/action/admin/staff/adminStaffAction.js
import {
  SET_ALL_DATA_OF_ADMIN_STAFF,
  SET_FILTERED_ADMIN_STAFF,
  RESET_ALL_ADMIN_STAFF_DATA,
  SET_STAFF_ADMIN_STAFF,
  SET_PAGES_DATA_ADMIN_STAFF,
} from "./type";

export const setAllDataOfAdminStaff = (data) => ({
  type: SET_ALL_DATA_OF_ADMIN_STAFF,
  payload: data,
});

export const setStaffAdminStaff = (staff) => ({
  type: SET_STAFF_ADMIN_STAFF,
  payload: staff,
});

export const setFilteredAdminStaff = (filtered) => ({
  type: SET_FILTERED_ADMIN_STAFF,
  payload: filtered,
});

export const setPagesDataAdminStaff = (data) => ({
  type: SET_PAGES_DATA_ADMIN_STAFF,
  payload: data,
});

export const resetAllAdminStaffData = () => ({
  type: RESET_ALL_ADMIN_STAFF_DATA,
});
